import Seo from "@/components/Seo";
import NavBar from "@/components/NavBar";
import Footer from "@/components/Footer";
import Contact from "@/components/Contact";
import { useLang } from "@/lib/i18n";

export default function ContactPage() {
  const { lang } = useLang();
  return (
    <div className="bg-[#050505] min-h-screen">
      <Seo
        title={lang === "zh" ? "商业对接 — DFE 娛樂夢工廠" : "Contact — Dream Factory Entertainment"}
        description={lang === "zh" ? "与 DFE 洽谈演唱会主办、艺人邀约与品牌活动合作：isaac@dfemalaysia.com / eileen@dfemalaysia.com" : "Talk to DFE about concerts, artist bookings and brand events: isaac@dfemalaysia.com / eileen@dfemalaysia.com"}
      />
      <NavBar />
      <main className="pt-16">
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
